<mat-toolbar class="titulopartes">Dados do Familiar</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxFlex="8%" style="text-align: end">
        <button name="fotoPerfil" ng mat-raised-button class="foto" [style.background-image]="getBackground()" >
            <mat-icon class="nao-foto"></mat-icon>
        </button>
    </div>
        
    <mat-form-field fxFlex="20%" fxFlexOffset="20px" >
        <input matInput name="nome" placeholder="Familiar" [(ngModel)]="familiar.pessoasFisica.nome" disabled>
    </mat-form-field>
    
    <mat-form-field fxFlex="20%" >
        <input matInput name="situacao" placeholder="Situação" [(ngModel)]="situacao" disabled>
    </mat-form-field>
        
    <mat-form-field fxFlex="10%" >
        <input matInput name="tutela" placeholder="Tutela" [(ngModel)]="tutela" disabled>
    </mat-form-field>
    
    <mat-form-field fxFlex="15%" >
        <input matInput name="transportaaluno" placeholder="Transporta o Aluno" [(ngModel)]="transpAluno" disabled>
    </mat-form-field>

    <mat-form-field fxFlex="15%" >
        <input matInput name="respfinanceiro" placeholder="Responsável Financeiro" [(ngModel)]="respFinc" disabled>
    </mat-form-field>

</div>


